import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStudioDisplay1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconStudioDisplay1"><Path d="M21.5 3.5H2.5V15.5H21.5V3.5Z" stroke="currentColor"/><Path d="M9.5 15.5V20.5H14.5V15.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconStudioDisplay1;
